'use strict';

var _ = require('lodash');
function KeyboardSaveController($scope, hotkeys, $timeout) {
  var assignKeyPromise;
  function assignKey(ev, toogleMode) {
    hotkeys.purgeHotkeys();
    if (assignKeyPromise) {
      $timeout.cancel(assignKeyPromise);
    }
    assignKeyPromise = $timeout(function () {
      hotkeys.bindTo($scope).add({
        combo: 'ctrl+s',
        description: 'Save Hotkey Implementation',
        callback: _.throttle(_.partial(save, toogleMode), 200)
      });
    }, 300);
  }
  function save(togleMode, ev) {
    $scope.$broadcast('keyboard:save', ev, togleMode);
    ev.preventDefault();
    ev.stopPropagation();
  }
  $scope.$on('search-criteria:searchChangeEvent', assignKey);
  $scope.$on('market-analysis-toggle:toggleMode', assignKey);
  assignKey();
}
KeyboardSaveController.$inject = ['$scope', 'hotkeys', '$timeout'];
module.exports = KeyboardSaveController;